export const normal = [
  0,
  0,
  0.9999999999999999,
  0,
  0,
  0.9999999999999999,
  0,
  0,
  0.9999999999999999,
  0,
  0,
  0.9999999999999999,
  0,
  0,
  0.9999999999999999,
  0,
  0,
  0.9999999999999999,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  -0.9999999999999999,
  0,
  0,
  -0.9999999999999999,
  0,
  0,
  -0.9999999999999999,
  0,
  0,
  -0.9999999999999999,
  0,
  0,
  -0.9999999999999999,
  0,
  0,
  -0.9999999999999999,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0.01777457490692761,
  0,
  -0.9998420197645616,
  0.01777457490692761,
  0,
  -0.9998420197645616,
  0.01777457490692761,
  0,
  -0.9998420197645616,
  0.01777457490692761,
  0,
  -0.9998420197645616,
  0.01777457490692761,
  0,
  -0.9998420197645616,
  0.01777457490692761,
  0,
  -0.9998420197645616,
  0.05325810111071037,
  0,
  -0.998580780240678,
  0.05325810111071037,
  0,
  -0.998580780240678,
  0.05325810111071037,
  0,
  -0.998580780240678,
  0.05325810111071037,
  0,
  -0.998580780240678,
  0.05325810111071037,
  0,
  -0.998580780240678,
  0.05325810111071037,
  0,
  -0.998580780240678,
  0.08853816601378267,
  0,
  -0.9960727850709082,
  0.08853816601378267,
  0,
  -0.9960727850709082,
  0.08853816601378267,
  0,
  -0.9960727850709082,
  0.08853816601378267,
  0,
  -0.9960727850709082,
  0.08853816601378267,
  0,
  -0.9960727850709082,
  0.08853816601378267,
  0,
  -0.9960727850709082,
  0.12349287975826849,
  0,
  -0.992345458320342,
  0.12349287975826849,
  0,
  -0.992345458320342,
  0.12349287975826849,
  0,
  -0.992345458320342,
  0.12349287975826849,
  0,
  -0.992345458320342,
  0.12349287975826849,
  0,
  -0.992345458320342,
  0.12349287975826849,
  0,
  -0.992345458320342,
  0.1579891713995488,
  0,
  -0.9874408446689269,
  0.1579891713995488,
  0,
  -0.9874408446689269,
  0.1579891713995488,
  0,
  -0.9874408446689269,
  0.1579891713995488,
  0,
  -0.9874408446689269,
  0.1579891713995488,
  0,
  -0.9874408446689269,
  0.1579891713995488,
  0,
  -0.9874408446689269,
  0.20842334106499186,
  0,
  -0.9780387062377981,
  0.20842334106499186,
  0,
  -0.9780387062377981,
  0.20842334106499186,
  0,
  -0.9780387062377981,
  0.20842334106499186,
  0,
  -0.9780387062377981,
  0.20842334106499186,
  0,
  -0.9780387062377981,
  0.20842334106499186,
  0,
  -0.9780387062377981,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -0.01777457490692761,
  0,
  -0.9998420197645616,
  -0.01777457490692761,
  0,
  -0.9998420197645616,
  -0.01777457490692761,
  0,
  -0.9998420197645616,
  -0.01777457490692761,
  0,
  -0.9998420197645616,
  -0.01777457490692761,
  0,
  -0.9998420197645616,
  -0.01777457490692761,
  0,
  -0.9998420197645616,
  -0.05325810111071037,
  0,
  -0.998580780240678,
  -0.05325810111071037,
  0,
  -0.998580780240678,
  -0.05325810111071037,
  0,
  -0.998580780240678,
  -0.05325810111071037,
  0,
  -0.998580780240678,
  -0.05325810111071037,
  0,
  -0.998580780240678,
  -0.05325810111071037,
  0,
  -0.998580780240678,
  -0.08853816601378267,
  0,
  -0.9960727850709082,
  -0.08853816601378267,
  0,
  -0.9960727850709082,
  -0.08853816601378267,
  0,
  -0.9960727850709082,
  -0.08853816601378267,
  0,
  -0.9960727850709082,
  -0.08853816601378267,
  0,
  -0.9960727850709082,
  -0.08853816601378267,
  0,
  -0.9960727850709082,
  -0.12349287975826849,
  0,
  -0.992345458320342,
  -0.12349287975826849,
  0,
  -0.992345458320342,
  -0.12349287975826849,
  0,
  -0.992345458320342,
  -0.12349287975826849,
  0,
  -0.992345458320342,
  -0.12349287975826849,
  0,
  -0.992345458320342,
  -0.12349287975826849,
  0,
  -0.992345458320342,
  -0.1579891713995488,
  0,
  -0.9874408446689269,
  -0.1579891713995488,
  0,
  -0.9874408446689269,
  -0.1579891713995488,
  0,
  -0.9874408446689269,
  -0.1579891713995488,
  0,
  -0.9874408446689269,
  -0.1579891713995488,
  0,
  -0.9874408446689269,
  -0.1579891713995488,
  0,
  -0.9874408446689269,
  -0.20842334106499186,
  0,
  -0.9780387062377981,
  -0.20842334106499186,
  0,
  -0.9780387062377981,
  -0.20842334106499186,
  0,
  -0.9780387062377981,
  -0.20842334106499186,
  0,
  -0.9780387062377981,
  -0.20842334106499186,
  0,
  -0.9780387062377981,
  -0.20842334106499186,
  0,
  -0.9780387062377981,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  0.9999999999999999,
  0,
  0,
  0.9999999999999999,
  0,
  0,
  0.9999999999999999,
  0,
  0,
  0.9999999999999999,
  0,
  0,
  0.9999999999999999,
  0,
  0,
  0.9999999999999999,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  -0.9999999999999999,
  0,
  0,
  -0.9999999999999999,
  0,
  0,
  -0.9999999999999999,
  0,
  0,
  -0.9999999999999999,
  0,
  0,
  -0.9999999999999999,
  0,
  0,
  -0.9999999999999999,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  -0.7998971075825987,
  0,
  -0.6001371653888738,
  -0.7998971075825987,
  0,
  -0.6001371653888738,
  -0.7998971075825987,
  0,
  -0.6001371653888738,
  -0.7998971075825987,
  0,
  -0.6001371653888738,
  -0.7998971075825987,
  0,
  -0.6001371653888738,
  -0.7998971075825987,
  0,
  -0.6001371653888738,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  -0.9086773748534248,
  0,
  0.41749901608206036,
  -0.9086773748534248,
  0,
  0.41749901608206036,
  -0.9086773748534248,
  0,
  0.41749901608206036,
  -0.9086773748534248,
  0,
  0.41749901608206036,
  -0.9086773748534248,
  0,
  0.41749901608206036,
  -0.9086773748534248,
  0,
  0.41749901608206036,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0.5982459446373243,
  0,
  -0.8013125418493058,
  0.5982459446373243,
  0,
  -0.8013125418493058,
  0.5982459446373243,
  0,
  -0.8013125418493058,
  0.5982459446373243,
  0,
  -0.8013125418493058,
  0.5982459446373243,
  0,
  -0.8013125418493058,
  0.5982459446373243,
  0,
  -0.8013125418493058,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  -0.8944004868981009,
  0,
  0.44726699971766287,
  -0.8944004868981009,
  0,
  0.44726699971766287,
  -0.8944004868981009,
  0,
  0.44726699971766287,
  -0.8944004868981009,
  0,
  0.44726699971766287,
  -0.8944004868981009,
  0,
  0.44726699971766287,
  -0.8944004868981009,
  0,
  0.44726699971766287,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0.49449252119652215,
  0,
  -0.8691818834287259,
  0.49449252119652215,
  0,
  -0.8691818834287259,
  0.49449252119652215,
  0,
  -0.8691818834287259,
  0.49449252119652215,
  0,
  -0.8691818834287259,
  0.49449252119652215,
  0,
  -0.8691818834287259,
  0.49449252119652215,
  0,
  -0.8691818834287259,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  -0.8796885554111684,
  0,
  0.4755502554710823,
  -0.8796885554111684,
  0,
  0.4755502554710823,
  -0.8796885554111684,
  0,
  0.4755502554710823,
  -0.8796885554111684,
  0,
  0.4755502554710823,
  -0.8796885554111684,
  0,
  0.4755502554710823,
  -0.8796885554111684,
  0,
  0.4755502554710823,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0.3642584895961771,
  0,
  -0.9312978861551826,
  0.3642584895961771,
  0,
  -0.9312978861551826,
  0.3642584895961771,
  0,
  -0.9312978861551826,
  0.3642584895961771,
  0,
  -0.9312978861551826,
  0.3642584895961771,
  0,
  -0.9312978861551826,
  0.3642584895961771,
  0,
  -0.9312978861551826,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0.8796885554111684,
  0,
  0.4755502554710823,
  0.8796885554111684,
  0,
  0.4755502554710823,
  0.8796885554111684,
  0,
  0.4755502554710823,
  0.8796885554111684,
  0,
  0.4755502554710823,
  0.8796885554111684,
  0,
  0.4755502554710823,
  0.8796885554111684,
  0,
  0.4755502554710823,
  -0.3642584895961771,
  0,
  -0.9312978861551826,
  -0.3642584895961771,
  0,
  -0.9312978861551826,
  -0.3642584895961771,
  0,
  -0.9312978861551826,
  -0.3642584895961771,
  0,
  -0.9312978861551826,
  -0.3642584895961771,
  0,
  -0.9312978861551826,
  -0.3642584895961771,
  0,
  -0.9312978861551826,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0.8944004868981009,
  0,
  0.44726699971766287,
  0.8944004868981009,
  0,
  0.44726699971766287,
  0.8944004868981009,
  0,
  0.44726699971766287,
  0.8944004868981009,
  0,
  0.44726699971766287,
  0.8944004868981009,
  0,
  0.44726699971766287,
  0.8944004868981009,
  0,
  0.44726699971766287,
  -0.49449252119652215,
  0,
  -0.8691818834287259,
  -0.49449252119652215,
  0,
  -0.8691818834287259,
  -0.49449252119652215,
  0,
  -0.8691818834287259,
  -0.49449252119652215,
  0,
  -0.8691818834287259,
  -0.49449252119652215,
  0,
  -0.8691818834287259,
  -0.49449252119652215,
  0,
  -0.8691818834287259,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0.9086773748534248,
  0,
  0.41749901608206036,
  0.9086773748534248,
  0,
  0.41749901608206036,
  0.9086773748534248,
  0,
  0.41749901608206036,
  0.9086773748534248,
  0,
  0.41749901608206036,
  0.9086773748534248,
  0,
  0.41749901608206036,
  0.9086773748534248,
  0,
  0.41749901608206036,
  -0.5982459446373243,
  0,
  -0.8013125418493058,
  -0.5982459446373243,
  0,
  -0.8013125418493058,
  -0.5982459446373243,
  0,
  -0.8013125418493058,
  -0.5982459446373243,
  0,
  -0.8013125418493058,
  -0.5982459446373243,
  0,
  -0.8013125418493058,
  -0.5982459446373243,
  0,
  -0.8013125418493058,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  0.7071067811865476,
  0,
  -0.7071067811865476,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  -0.7071067811865476,
  0,
  -0.7071067811865476,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0.7998971075825987,
  0,
  -0.6001371653888738,
  0.7998971075825987,
  0,
  -0.6001371653888738,
  0.7998971075825987,
  0,
  -0.6001371653888738,
  0.7998971075825987,
  0,
  -0.6001371653888738,
  0.7998971075825987,
  0,
  -0.6001371653888738,
  0.7998971075825987,
  0,
  -0.6001371653888738,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  -0.6148200568178559,
  0,
  0.7886674189634618,
  -0.6148200568178559,
  0,
  0.7886674189634618,
  -0.6148200568178559,
  0,
  0.7886674189634618,
  -0.6148200568178559,
  0,
  0.7886674189634618,
  -0.6148200568178559,
  0,
  0.7886674189634618,
  -0.6148200568178559,
  0,
  0.7886674189634618,
  -0.6014057211032096,
  0,
  0.7989437768856633,
  -0.6014057211032096,
  0,
  0.7989437768856633,
  -0.6014057211032096,
  0,
  0.7989437768856633,
  -0.6014057211032096,
  0,
  0.7989437768856633,
  -0.6014057211032096,
  0,
  0.7989437768856633,
  -0.6014057211032096,
  0,
  0.7989437768856633,
  -0.5950580128494584,
  0,
  0.8036827491887917,
  -0.5950580128494584,
  0,
  0.8036827491887917,
  -0.5950580128494584,
  0,
  0.8036827491887917,
  -0.5950580128494584,
  0,
  0.8036827491887917,
  -0.5950580128494584,
  0,
  0.8036827491887917,
  -0.5950580128494584,
  0,
  0.8036827491887917,
  -0.5857399523963472,
  0,
  0.8104990488376435,
  -0.5857399523963472,
  0,
  0.8104990488376435,
  -0.5857399523963472,
  0,
  0.8104990488376435,
  -0.5857399523963472,
  0,
  0.8104990488376435,
  -0.5857399523963472,
  0,
  0.8104990488376435,
  -0.5857399523963472,
  0,
  0.8104990488376435,
  -0.5697792546692328,
  0,
  0.8217977859233825,
  -0.5697792546692328,
  0,
  0.8217977859233825,
  -0.5697792546692328,
  0,
  0.8217977859233825,
  -0.5697792546692328,
  0,
  0.8217977859233825,
  -0.5697792546692328,
  0,
  0.8217977859233825,
  -0.5697792546692328,
  0,
  0.8217977859233825,
  -0.5495440610825559,
  0,
  0.8354647358978667,
  -0.5495440610825559,
  0,
  0.8354647358978667,
  -0.5495440610825559,
  0,
  0.8354647358978667,
  -0.5495440610825559,
  0,
  0.8354647358978667,
  -0.5495440610825559,
  0,
  0.8354647358978667,
  -0.5495440610825559,
  0,
  0.8354647358978667,
  -0.5283045836878755,
  0,
  0.8490549256993806,
  -0.5283045836878755,
  0,
  0.8490549256993806,
  -0.5283045836878755,
  0,
  0.8490549256993806,
  -0.5283045836878755,
  0,
  0.8490549256993806,
  -0.5283045836878755,
  0,
  0.8490549256993806,
  -0.5283045836878755,
  0,
  0.8490549256993806,
  -0.5099756529005712,
  0,
  0.8601888359242034,
  -0.5099756529005712,
  0,
  0.8601888359242034,
  -0.5099756529005712,
  0,
  0.8601888359242034,
  -0.5099756529005712,
  0,
  0.8601888359242034,
  -0.5099756529005712,
  0,
  0.8601888359242034,
  -0.5099756529005712,
  0,
  0.8601888359242034,
  -0.4986002277633216,
  0,
  0.8668320557491882,
  -0.4986002277633216,
  0,
  0.8668320557491882,
  -0.4986002277633216,
  0,
  0.8668320557491882,
  -0.4986002277633216,
  0,
  0.8668320557491882,
  -0.4986002277633216,
  0,
  0.8668320557491882,
  -0.4986002277633216,
  0,
  0.8668320557491882,
  -0.49035258944682203,
  0,
  0.8715241465517732,
  -0.49035258944682203,
  0,
  0.8715241465517732,
  -0.49035258944682203,
  0,
  0.8715241465517732,
  -0.49035258944682203,
  0,
  0.8715241465517732,
  -0.49035258944682203,
  0,
  0.8715241465517732,
  -0.49035258944682203,
  0,
  0.8715241465517732,
  -0.47844804428463894,
  0,
  0.8781158630387019,
  -0.47844804428463894,
  0,
  0.8781158630387019,
  -0.47844804428463894,
  0,
  0.8781158630387019,
  -0.47844804428463894,
  0,
  0.8781158630387019,
  -0.47844804428463894,
  0,
  0.8781158630387019,
  -0.47844804428463894,
  0,
  0.8781158630387019,
  -0.4582326472859353,
  0,
  0.8888322906833008,
  -0.4582326472859353,
  0,
  0.8888322906833008,
  -0.4582326472859353,
  0,
  0.8888322906833008,
  -0.4582326472859353,
  0,
  0.8888322906833008,
  -0.4582326472859353,
  0,
  0.8888322906833008,
  -0.4582326472859353,
  0,
  0.8888322906833008,
  -0.4327368688824879,
  0,
  0.9015202728224033,
  -0.4327368688824879,
  0,
  0.9015202728224033,
  -0.4327368688824879,
  0,
  0.9015202728224033,
  -0.4327368688824879,
  0,
  0.9015202728224033,
  -0.4327368688824879,
  0,
  0.9015202728224033,
  -0.4327368688824879,
  0,
  0.9015202728224033,
  -0.40615775834904544,
  0,
  0.9138029740227804,
  -0.40615775834904544,
  0,
  0.9138029740227804,
  -0.40615775834904544,
  0,
  0.9138029740227804,
  -0.40615775834904544,
  0,
  0.9138029740227804,
  -0.40615775834904544,
  0,
  0.9138029740227804,
  -0.40615775834904544,
  0,
  0.9138029740227804,
  -0.38338784841352397,
  0,
  0.9235874391138333,
  -0.38338784841352397,
  0,
  0.9235874391138333,
  -0.38338784841352397,
  0,
  0.9235874391138333,
  -0.38338784841352397,
  0,
  0.9235874391138333,
  -0.38338784841352397,
  0,
  0.9235874391138333,
  -0.38338784841352397,
  0,
  0.9235874391138333,
  -0.36923970139415646,
  0,
  0.9293341933418539,
  -0.36923970139415646,
  0,
  0.9293341933418539,
  -0.36923970139415646,
  0,
  0.9293341933418539,
  -0.36923970139415646,
  0,
  0.9293341933418539,
  -0.36923970139415646,
  0,
  0.9293341933418539,
  -0.36923970139415646,
  0,
  0.9293341933418539,
  -0.3592458180914065,
  0,
  0.9332429706051025,
  -0.3592458180914065,
  0,
  0.9332429706051025,
  -0.3592458180914065,
  0,
  0.9332429706051025,
  -0.3592458180914065,
  0,
  0.9332429706051025,
  -0.3592458180914065,
  0,
  0.9332429706051025,
  -0.3592458180914065,
  0,
  0.9332429706051025,
  -0.3445985255654837,
  0,
  0.9387501564197446,
  -0.3445985255654837,
  0,
  0.9387501564197446,
  -0.3445985255654837,
  0,
  0.9387501564197446,
  -0.3445985255654837,
  0,
  0.9387501564197446,
  -0.3445985255654837,
  0,
  0.9387501564197446,
  -0.3445985255654837,
  0,
  0.9387501564197446,
  -0.3200136233245497,
  0,
  0.9474129410593319,
  -0.3200136233245497,
  0,
  0.9474129410593319,
  -0.3200136233245497,
  0,
  0.9474129410593319,
  -0.3200136233245497,
  0,
  0.9474129410593319,
  -0.3200136233245497,
  0,
  0.9474129410593319,
  -0.3200136233245497,
  0,
  0.9474129410593319,
  -0.28929803780636554,
  0,
  0.9572390742763203,
  -0.28929803780636554,
  0,
  0.9572390742763203,
  -0.28929803780636554,
  0,
  0.9572390742763203,
  -0.28929803780636554,
  0,
  0.9572390742763203,
  -0.28929803780636554,
  0,
  0.9572390742763203,
  -0.28929803780636554,
  0,
  0.9572390742763203,
  -0.25766175990060225,
  0,
  0.966235177110068,
  -0.25766175990060225,
  0,
  0.966235177110068,
  -0.25766175990060225,
  0,
  0.966235177110068,
  -0.25766175990060225,
  0,
  0.966235177110068,
  -0.25766175990060225,
  0,
  0.966235177110068,
  -0.25766175990060225,
  0,
  0.966235177110068,
  -0.22517555006551684,
  0,
  0.9743182086221583,
  -0.22517555006551684,
  0,
  0.9743182086221583,
  -0.22517555006551684,
  0,
  0.9743182086221583,
  -0.22517555006551684,
  0,
  0.9743182086221583,
  -0.22517555006551684,
  0,
  0.9743182086221583,
  -0.22517555006551684,
  0,
  0.9743182086221583,
  -0.19191862106877114,
  0,
  0.9814108430657679,
  -0.19191862106877114,
  0,
  0.9814108430657679,
  -0.19191862106877114,
  0,
  0.9814108430657679,
  -0.19191862106877114,
  0,
  0.9814108430657679,
  -0.19191862106877114,
  0,
  0.9814108430657679,
  -0.19191862106877114,
  0,
  0.9814108430657679,
  -0.1579891713995488,
  0,
  0.9874408446689269,
  -0.1579891713995488,
  0,
  0.9874408446689269,
  -0.1579891713995488,
  0,
  0.9874408446689269,
  -0.1579891713995488,
  0,
  0.9874408446689269,
  -0.1579891713995488,
  0,
  0.9874408446689269,
  -0.1579891713995488,
  0,
  0.9874408446689269,
  -0.12349287975826849,
  0,
  0.992345458320342,
  -0.12349287975826849,
  0,
  0.992345458320342,
  -0.12349287975826849,
  0,
  0.992345458320342,
  -0.12349287975826849,
  0,
  0.992345458320342,
  -0.12349287975826849,
  0,
  0.992345458320342,
  -0.12349287975826849,
  0,
  0.992345458320342,
  -0.08853816601378267,
  0,
  0.9960727850709082,
  -0.08853816601378267,
  0,
  0.9960727850709082,
  -0.08853816601378267,
  0,
  0.9960727850709082,
  -0.08853816601378267,
  0,
  0.9960727850709082,
  -0.08853816601378267,
  0,
  0.9960727850709082,
  -0.08853816601378267,
  0,
  0.9960727850709082,
  -0.05325810111071037,
  0,
  0.998580780240678,
  -0.05325810111071037,
  0,
  0.998580780240678,
  -0.05325810111071037,
  0,
  0.998580780240678,
  -0.05325810111071037,
  0,
  0.998580780240678,
  -0.05325810111071037,
  0,
  0.998580780240678,
  -0.05325810111071037,
  0,
  0.998580780240678,
  -0.01777457490692761,
  0,
  0.9998420197645616,
  -0.01777457490692761,
  0,
  0.9998420197645616,
  -0.01777457490692761,
  0,
  0.9998420197645616,
  -0.01777457490692761,
  0,
  0.9998420197645616,
  -0.01777457490692761,
  0,
  0.9998420197645616,
  -0.01777457490692761,
  0,
  0.9998420197645616,
  0.01777457490692761,
  0,
  0.9998420197645616,
  0.01777457490692761,
  0,
  0.9998420197645616,
  0.01777457490692761,
  0,
  0.9998420197645616,
  0.01777457490692761,
  0,
  0.9998420197645616,
  0.01777457490692761,
  0,
  0.9998420197645616,
  0.01777457490692761,
  0,
  0.9998420197645616,
  0.05325810111071037,
  0,
  0.998580780240678,
  0.05325810111071037,
  0,
  0.998580780240678,
  0.05325810111071037,
  0,
  0.998580780240678,
  0.05325810111071037,
  0,
  0.998580780240678,
  0.05325810111071037,
  0,
  0.998580780240678,
  0.05325810111071037,
  0,
  0.998580780240678,
  0.08853816601378267,
  0,
  0.9960727850709082,
  0.08853816601378267,
  0,
  0.9960727850709082,
  0.08853816601378267,
  0,
  0.9960727850709082,
  0.08853816601378267,
  0,
  0.9960727850709082,
  0.08853816601378267,
  0,
  0.9960727850709082,
  0.08853816601378267,
  0,
  0.9960727850709082,
  0.12349287975826849,
  0,
  0.992345458320342,
  0.12349287975826849,
  0,
  0.992345458320342,
  0.12349287975826849,
  0,
  0.992345458320342,
  0.12349287975826849,
  0,
  0.992345458320342,
  0.12349287975826849,
  0,
  0.992345458320342,
  0.12349287975826849,
  0,
  0.992345458320342,
  0.1579891713995488,
  0,
  0.9874408446689269,
  0.1579891713995488,
  0,
  0.9874408446689269,
  0.1579891713995488,
  0,
  0.9874408446689269,
  0.1579891713995488,
  0,
  0.9874408446689269,
  0.1579891713995488,
  0,
  0.9874408446689269,
  0.1579891713995488,
  0,
  0.9874408446689269,
  0.19191862106877114,
  0,
  0.9814108430657679,
  0.19191862106877114,
  0,
  0.9814108430657679,
  0.19191862106877114,
  0,
  0.9814108430657679,
  0.19191862106877114,
  0,
  0.9814108430657679,
  0.19191862106877114,
  0,
  0.9814108430657679,
  0.19191862106877114,
  0,
  0.9814108430657679,
  0.22517555006551684,
  0,
  0.9743182086221583,
  0.22517555006551684,
  0,
  0.9743182086221583,
  0.22517555006551684,
  0,
  0.9743182086221583,
  0.22517555006551684,
  0,
  0.9743182086221583,
  0.22517555006551684,
  0,
  0.9743182086221583,
  0.22517555006551684,
  0,
  0.9743182086221583,
  0.25766175990060225,
  0,
  0.966235177110068,
  0.25766175990060225,
  0,
  0.966235177110068,
  0.25766175990060225,
  0,
  0.966235177110068,
  0.25766175990060225,
  0,
  0.966235177110068,
  0.25766175990060225,
  0,
  0.966235177110068,
  0.25766175990060225,
  0,
  0.966235177110068,
  0.28929803780636554,
  0,
  0.9572390742763203,
  0.28929803780636554,
  0,
  0.9572390742763203,
  0.28929803780636554,
  0,
  0.9572390742763203,
  0.28929803780636554,
  0,
  0.9572390742763203,
  0.28929803780636554,
  0,
  0.9572390742763203,
  0.28929803780636554,
  0,
  0.9572390742763203,
  0.3200136233245497,
  0,
  0.9474129410593319,
  0.3200136233245497,
  0,
  0.9474129410593319,
  0.3200136233245497,
  0,
  0.9474129410593319,
  0.3200136233245497,
  0,
  0.9474129410593319,
  0.3200136233245497,
  0,
  0.9474129410593319,
  0.3200136233245497,
  0,
  0.9474129410593319,
  0.3445985255654837,
  0,
  0.9387501564197446,
  0.3445985255654837,
  0,
  0.9387501564197446,
  0.3445985255654837,
  0,
  0.9387501564197446,
  0.3445985255654837,
  0,
  0.9387501564197446,
  0.3445985255654837,
  0,
  0.9387501564197446,
  0.3445985255654837,
  0,
  0.9387501564197446,
  0.3592458180914065,
  0,
  0.9332429706051025,
  0.3592458180914065,
  0,
  0.9332429706051025,
  0.3592458180914065,
  0,
  0.9332429706051025,
  0.3592458180914065,
  0,
  0.9332429706051025,
  0.3592458180914065,
  0,
  0.9332429706051025,
  0.3592458180914065,
  0,
  0.9332429706051025,
  0.36923970139415646,
  0,
  0.9293341933418539,
  0.36923970139415646,
  0,
  0.9293341933418539,
  0.36923970139415646,
  0,
  0.9293341933418539,
  0.36923970139415646,
  0,
  0.9293341933418539,
  0.36923970139415646,
  0,
  0.9293341933418539,
  0.36923970139415646,
  0,
  0.9293341933418539,
  0.38338784841352397,
  0,
  0.9235874391138333,
  0.38338784841352397,
  0,
  0.9235874391138333,
  0.38338784841352397,
  0,
  0.9235874391138333,
  0.38338784841352397,
  0,
  0.9235874391138333,
  0.38338784841352397,
  0,
  0.9235874391138333,
  0.38338784841352397,
  0,
  0.9235874391138333,
  0.40615775834904544,
  0,
  0.9138029740227804,
  0.40615775834904544,
  0,
  0.9138029740227804,
  0.40615775834904544,
  0,
  0.9138029740227804,
  0.40615775834904544,
  0,
  0.9138029740227804,
  0.40615775834904544,
  0,
  0.9138029740227804,
  0.40615775834904544,
  0,
  0.9138029740227804,
  0.4327368688824879,
  0,
  0.9015202728224033,
  0.4327368688824879,
  0,
  0.9015202728224033,
  0.4327368688824879,
  0,
  0.9015202728224033,
  0.4327368688824879,
  0,
  0.9015202728224033,
  0.4327368688824879,
  0,
  0.9015202728224033,
  0.4327368688824879,
  0,
  0.9015202728224033,
  0.4582326472859353,
  0,
  0.8888322906833008,
  0.4582326472859353,
  0,
  0.8888322906833008,
  0.4582326472859353,
  0,
  0.8888322906833008,
  0.4582326472859353,
  0,
  0.8888322906833008,
  0.4582326472859353,
  0,
  0.8888322906833008,
  0.4582326472859353,
  0,
  0.8888322906833008,
  0.47844804428463894,
  0,
  0.8781158630387019,
  0.47844804428463894,
  0,
  0.8781158630387019,
  0.47844804428463894,
  0,
  0.8781158630387019,
  0.47844804428463894,
  0,
  0.8781158630387019,
  0.47844804428463894,
  0,
  0.8781158630387019,
  0.47844804428463894,
  0,
  0.8781158630387019,
  0.49035258944682203,
  0,
  0.8715241465517732,
  0.49035258944682203,
  0,
  0.8715241465517732,
  0.49035258944682203,
  0,
  0.8715241465517732,
  0.49035258944682203,
  0,
  0.8715241465517732,
  0.49035258944682203,
  0,
  0.8715241465517732,
  0.49035258944682203,
  0,
  0.8715241465517732,
  0.4986002277633216,
  0,
  0.8668320557491882,
  0.4986002277633216,
  0,
  0.8668320557491882,
  0.4986002277633216,
  0,
  0.8668320557491882,
  0.4986002277633216,
  0,
  0.8668320557491882,
  0.4986002277633216,
  0,
  0.8668320557491882,
  0.4986002277633216,
  0,
  0.8668320557491882,
  0.5099756529005712,
  0,
  0.8601888359242034,
  0.5099756529005712,
  0,
  0.8601888359242034,
  0.5099756529005712,
  0,
  0.8601888359242034,
  0.5099756529005712,
  0,
  0.8601888359242034,
  0.5099756529005712,
  0,
  0.8601888359242034,
  0.5099756529005712,
  0,
  0.8601888359242034,
  0.5283045836878755,
  0,
  0.8490549256993806,
  0.5283045836878755,
  0,
  0.8490549256993806,
  0.5283045836878755,
  0,
  0.8490549256993806,
  0.5283045836878755,
  0,
  0.8490549256993806,
  0.5283045836878755,
  0,
  0.8490549256993806,
  0.5283045836878755,
  0,
  0.8490549256993806,
  0.5495440610825559,
  0,
  0.8354647358978667,
  0.5495440610825559,
  0,
  0.8354647358978667,
  0.5495440610825559,
  0,
  0.8354647358978667,
  0.5495440610825559,
  0,
  0.8354647358978667,
  0.5495440610825559,
  0,
  0.8354647358978667,
  0.5495440610825559,
  0,
  0.8354647358978667,
  0.5697792546692328,
  0,
  0.8217977859233825,
  0.5697792546692328,
  0,
  0.8217977859233825,
  0.5697792546692328,
  0,
  0.8217977859233825,
  0.5697792546692328,
  0,
  0.8217977859233825,
  0.5697792546692328,
  0,
  0.8217977859233825,
  0.5697792546692328,
  0,
  0.8217977859233825,
  0.5857399523963472,
  0,
  0.8104990488376435,
  0.5857399523963472,
  0,
  0.8104990488376435,
  0.5857399523963472,
  0,
  0.8104990488376435,
  0.5857399523963472,
  0,
  0.8104990488376435,
  0.5857399523963472,
  0,
  0.8104990488376435,
  0.5857399523963472,
  0,
  0.8104990488376435,
  0.5950580128494584,
  0,
  0.8036827491887917,
  0.5950580128494584,
  0,
  0.8036827491887917,
  0.5950580128494584,
  0,
  0.8036827491887917,
  0.5950580128494584,
  0,
  0.8036827491887917,
  0.5950580128494584,
  0,
  0.8036827491887917,
  0.5950580128494584,
  0,
  0.8036827491887917,
  0.6014057211032096,
  0,
  0.7989437768856633,
  0.6014057211032096,
  0,
  0.7989437768856633,
  0.6014057211032096,
  0,
  0.7989437768856633,
  0.6014057211032096,
  0,
  0.7989437768856633,
  0.6014057211032096,
  0,
  0.7989437768856633,
  0.6014057211032096,
  0,
  0.7989437768856633,
  0.6148200568178559,
  0,
  0.7886674189634618,
  0.6148200568178559,
  0,
  0.7886674189634618,
  0.6148200568178559,
  0,
  0.7886674189634618,
  0.6148200568178559,
  0,
  0.7886674189634618,
  0.6148200568178559,
  0,
  0.7886674189634618,
  0.6148200568178559,
  0,
  0.7886674189634618,
  0.7808668582275605,
  0,
  -0.6246974865659528,
  0.7808668582275605,
  0,
  -0.6246974865659528,
  0.7808668582275605,
  0,
  -0.6246974865659528,
  0.7808668582275605,
  0,
  -0.6246974865659528,
  0.7808668582275605,
  0,
  -0.6246974865659528,
  0.7808668582275605,
  0,
  -0.6246974865659528,
  -0.6148034020884103,
  0,
  -0.7886804021785482,
  -0.6148034020884103,
  0,
  -0.7886804021785482,
  -0.6148034020884103,
  0,
  -0.7886804021785482,
  -0.6148034020884103,
  0,
  -0.7886804021785482,
  -0.6148034020884103,
  0,
  -0.7886804021785482,
  -0.6148034020884103,
  0,
  -0.7886804021785482,
  -0.6014611133277081,
  0,
  -0.7989020773252462,
  -0.6014611133277081,
  0,
  -0.7989020773252462,
  -0.6014611133277081,
  0,
  -0.7989020773252462,
  -0.6014611133277081,
  0,
  -0.7989020773252462,
  -0.6014611133277081,
  0,
  -0.7989020773252462,
  -0.6014611133277081,
  0,
  -0.7989020773252462,
  -0.59510704228549,
  0,
  -0.8036464447891347,
  -0.59510704228549,
  0,
  -0.8036464447891347,
  -0.59510704228549,
  0,
  -0.8036464447891347,
  -0.59510704228549,
  0,
  -0.8036464447891347,
  -0.59510704228549,
  0,
  -0.8036464447891347,
  -0.59510704228549,
  0,
  -0.8036464447891347,
  -0.5857392008968432,
  0,
  -0.810499591938656,
  -0.5857392008968432,
  0,
  -0.810499591938656,
  -0.5857392008968432,
  0,
  -0.810499591938656,
  -0.5857392008968432,
  0,
  -0.810499591938656,
  -0.5857392008968432,
  0,
  -0.810499591938656,
  -0.5857392008968432,
  0,
  -0.810499591938656,
  -0.5697616492287497,
  0,
  -0.8218099920712423,
  -0.5697616492287497,
  0,
  -0.8218099920712423,
  -0.5697616492287497,
  0,
  -0.8218099920712423,
  -0.5697616492287497,
  0,
  -0.8218099920712423,
  -0.5697616492287497,
  0,
  -0.8218099920712423,
  -0.5697616492287497,
  0,
  -0.8218099920712423,
  -0.5495745473540692,
  0,
  -0.8354446821307621,
  -0.5495745473540692,
  0,
  -0.8354446821307621,
  -0.5495745473540692,
  0,
  -0.8354446821307621,
  -0.5495745473540692,
  0,
  -0.8354446821307621,
  -0.5495745473540692,
  0,
  -0.8354446821307621,
  -0.5495745473540692,
  0,
  -0.8354446821307621,
  -0.5282812148449356,
  0,
  -0.8490694659696336,
  -0.5282812148449356,
  0,
  -0.8490694659696336,
  -0.5282812148449356,
  0,
  -0.8490694659696336,
  -0.5282812148449356,
  0,
  -0.8490694659696336,
  -0.5282812148449356,
  0,
  -0.8490694659696336,
  -0.5282812148449356,
  0,
  -0.8490694659696336,
  -0.5100296559885893,
  0,
  -0.8601568171049749,
  -0.5100296559885893,
  0,
  -0.8601568171049749,
  -0.5100296559885893,
  0,
  -0.8601568171049749,
  -0.5100296559885893,
  0,
  -0.8601568171049749,
  -0.5100296559885893,
  0,
  -0.8601568171049749,
  -0.5100296559885893,
  0,
  -0.8601568171049749,
  -0.49847112425808165,
  0,
  -0.8669063030575358,
  -0.49847112425808165,
  0,
  -0.8669063030575358,
  -0.49847112425808165,
  0,
  -0.8669063030575358,
  -0.49847112425808165,
  0,
  -0.8669063030575358,
  -0.49847112425808165,
  0,
  -0.8669063030575358,
  -0.49847112425808165,
  0,
  -0.8669063030575358,
  -0.4904483172997039,
  0,
  -0.8714702795034888,
  -0.4904483172997039,
  0,
  -0.8714702795034888,
  -0.4904483172997039,
  0,
  -0.8714702795034888,
  -0.4904483172997039,
  0,
  -0.8714702795034888,
  -0.4904483172997039,
  0,
  -0.8714702795034888,
  -0.4904483172997039,
  0,
  -0.8714702795034888,
  -0.47841610365634096,
  0,
  -0.8781332653773486,
  -0.47841610365634096,
  0,
  -0.8781332653773486,
  -0.47841610365634096,
  0,
  -0.8781332653773486,
  -0.47841610365634096,
  0,
  -0.8781332653773486,
  -0.47841610365634096,
  0,
  -0.8781332653773486,
  -0.47841610365634096,
  0,
  -0.8781332653773486,
  -0.45824591679032706,
  0,
  -0.8888254495371927,
  -0.45824591679032706,
  0,
  -0.8888254495371927,
  -0.45824591679032706,
  0,
  -0.8888254495371927,
  -0.45824591679032706,
  0,
  -0.8888254495371927,
  -0.45824591679032706,
  0,
  -0.8888254495371927,
  -0.45824591679032706,
  0,
  -0.8888254495371927,
  -0.43275786520554677,
  0,
  -0.901510194120254,
  -0.43275786520554677,
  0,
  -0.901510194120254,
  -0.43275786520554677,
  0,
  -0.901510194120254,
  -0.43275786520554677,
  0,
  -0.901510194120254,
  -0.43275786520554677,
  0,
  -0.901510194120254,
  -0.43275786520554677,
  0,
  -0.901510194120254,
  -0.40611174886474966,
  0,
  -0.9138234224586359,
  -0.40611174886474966,
  0,
  -0.9138234224586359,
  -0.40611174886474966,
  0,
  -0.9138234224586359,
  -0.40611174886474966,
  0,
  -0.9138234224586359,
  -0.40611174886474966,
  0,
  -0.9138234224586359,
  -0.40611174886474966,
  0,
  -0.9138234224586359,
  -0.38343280259308943,
  0,
  -0.9235687770250839,
  -0.38343280259308943,
  0,
  -0.9235687770250839,
  -0.38343280259308943,
  0,
  -0.9235687770250839,
  -0.38343280259308943,
  0,
  -0.9235687770250839,
  -0.38343280259308943,
  0,
  -0.9235687770250839,
  -0.38343280259308943,
  0,
  -0.9235687770250839,
  -0.3692704150425044,
  0,
  -0.9293219897184918,
  -0.3692704150425044,
  0,
  -0.9293219897184918,
  -0.3692704150425044,
  0,
  -0.9293219897184918,
  -0.3692704150425044,
  0,
  -0.9293219897184918,
  -0.3692704150425044,
  0,
  -0.9293219897184918,
  -0.3692704150425044,
  0,
  -0.9293219897184918,
  -0.3591263346811636,
  0,
  -0.9332889561858497,
  -0.3591263346811636,
  0,
  -0.9332889561858497,
  -0.3591263346811636,
  0,
  -0.9332889561858497,
  -0.3591263346811636,
  0,
  -0.9332889561858497,
  -0.3591263346811636,
  0,
  -0.9332889561858497,
  -0.3591263346811636,
  0,
  -0.9332889561858497,
  -0.3446300199038612,
  0,
  -0.938738594807449,
  -0.3446300199038612,
  0,
  -0.938738594807449,
  -0.3446300199038612,
  0,
  -0.938738594807449,
  -0.3446300199038612,
  0,
  -0.938738594807449,
  -0.3446300199038612,
  0,
  -0.938738594807449,
  -0.3446300199038612,
  0,
  -0.938738594807449,
  -0.32002313053853576,
  0,
  -0.9474097296947691,
  -0.32002313053853576,
  0,
  -0.9474097296947691,
  -0.32002313053853576,
  0,
  -0.9474097296947691,
  -0.32002313053853576,
  0,
  -0.9474097296947691,
  -0.32002313053853576,
  0,
  -0.9474097296947691,
  -0.32002313053853576,
  0,
  -0.9474097296947691,
  -0.28929201338125,
  0,
  -0.9572408949652239,
  -0.28929201338125,
  0,
  -0.9572408949652239,
  -0.28929201338125,
  0,
  -0.9572408949652239,
  -0.28929201338125,
  0,
  -0.9572408949652239,
  -0.28929201338125,
  0,
  -0.9572408949652239,
  -0.28929201338125,
  0,
  -0.9572408949652239,
  -0.2576687824952253,
  0,
  -0.9662333043977673,
  -0.2576687824952253,
  0,
  -0.9662333043977673,
  -0.2576687824952253,
  0,
  -0.9662333043977673,
  -0.2576687824952253,
  0,
  -0.9662333043977673,
  -0.2576687824952253,
  0,
  -0.9662333043977673,
  -0.2576687824952253,
  0,
  -0.9662333043977673,
  -0.22517453682616517,
  0,
  -0.9743184427922535,
  -0.22517453682616517,
  0,
  -0.9743184427922535,
  -0.22517453682616517,
  0,
  -0.9743184427922535,
  -0.22517453682616517,
  0,
  -0.9743184427922535,
  -0.22517453682616517,
  0,
  -0.9743184427922535,
  -0.22517453682616517,
  0,
  -0.9743184427922535,
  -0.19192688212649994,
  0,
  -0.9814092275484271,
  -0.19192688212649994,
  0,
  -0.9814092275484271,
  -0.19192688212649994,
  0,
  -0.9814092275484271,
  -0.19192688212649994,
  0,
  -0.9814092275484271,
  -0.19192688212649994,
  0,
  -0.9814092275484271,
  -0.19192688212649994,
  0,
  -0.9814092275484271,
  -0.1579869623626288,
  0,
  -0.9874411981092491,
  -0.1579869623626288,
  0,
  -0.9874411981092491,
  -0.1579869623626288,
  0,
  -0.9874411981092491,
  -0.1579869623626288,
  0,
  -0.9874411981092491,
  -0.1579869623626288,
  0,
  -0.9874411981092491,
  -0.1579869623626288,
  0,
  -0.9874411981092491,
  -0.12349087432677118,
  0,
  -0.9923457078851149,
  -0.12349087432677118,
  0,
  -0.9923457078851149,
  -0.12349087432677118,
  0,
  -0.9923457078851149,
  -0.12349087432677118,
  0,
  -0.9923457078851149,
  -0.12349087432677118,
  0,
  -0.9923457078851149,
  -0.12349087432677118,
  0,
  -0.9923457078851149,
  -0.08854472583557775,
  0,
  -0.996072201964648,
  -0.08854472583557775,
  0,
  -0.996072201964648,
  -0.08854472583557775,
  0,
  -0.996072201964648,
  -0.08854472583557775,
  0,
  -0.996072201964648,
  -0.08854472583557775,
  0,
  -0.996072201964648,
  -0.08854472583557775,
  0,
  -0.996072201964648,
  -0.05325710032566384,
  0,
  -0.9985808336158382,
  -0.05325710032566384,
  0,
  -0.9985808336158382,
  -0.05325710032566384,
  0,
  -0.9985808336158382,
  -0.05325710032566384,
  0,
  -0.9985808336158382,
  -0.05325710032566384,
  0,
  -0.9985808336158382,
  -0.05325710032566384,
  0,
  -0.9985808336158382,
  -0.017776240067030172,
  0,
  -0.9998419901609851,
  -0.017776240067030172,
  0,
  -0.9998419901609851,
  -0.017776240067030172,
  0,
  -0.9998419901609851,
  -0.017776240067030172,
  0,
  -0.9998419901609851,
  -0.017776240067030172,
  0,
  -0.9998419901609851,
  -0.017776240067030172,
  0,
  -0.9998419901609851,
  0.017776240067030172,
  0,
  -0.9998419901609851,
  0.017776240067030172,
  0,
  -0.9998419901609851,
  0.017776240067030172,
  0,
  -0.9998419901609851,
  0.017776240067030172,
  0,
  -0.9998419901609851,
  0.017776240067030172,
  0,
  -0.9998419901609851,
  0.017776240067030172,
  0,
  -0.9998419901609851,
  0.05325710032566384,
  0,
  -0.9985808336158382,
  0.05325710032566384,
  0,
  -0.9985808336158382,
  0.05325710032566384,
  0,
  -0.9985808336158382,
  0.05325710032566384,
  0,
  -0.9985808336158382,
  0.05325710032566384,
  0,
  -0.9985808336158382,
  0.05325710032566384,
  0,
  -0.9985808336158382,
  0.08854472583557775,
  0,
  -0.996072201964648,
  0.08854472583557775,
  0,
  -0.996072201964648,
  0.08854472583557775,
  0,
  -0.996072201964648,
  0.08854472583557775,
  0,
  -0.996072201964648,
  0.08854472583557775,
  0,
  -0.996072201964648,
  0.08854472583557775,
  0,
  -0.996072201964648,
  0.12349087432677118,
  0,
  -0.9923457078851149,
  0.12349087432677118,
  0,
  -0.9923457078851149,
  0.12349087432677118,
  0,
  -0.9923457078851149,
  0.12349087432677118,
  0,
  -0.9923457078851149,
  0.12349087432677118,
  0,
  -0.9923457078851149,
  0.12349087432677118,
  0,
  -0.9923457078851149,
  0.1579869623626288,
  0,
  -0.9874411981092491,
  0.1579869623626288,
  0,
  -0.9874411981092491,
  0.1579869623626288,
  0,
  -0.9874411981092491,
  0.1579869623626288,
  0,
  -0.9874411981092491,
  0.1579869623626288,
  0,
  -0.9874411981092491,
  0.1579869623626288,
  0,
  -0.9874411981092491,
  0.19192688212649994,
  0,
  -0.9814092275484271,
  0.19192688212649994,
  0,
  -0.9814092275484271,
  0.19192688212649994,
  0,
  -0.9814092275484271,
  0.19192688212649994,
  0,
  -0.9814092275484271,
  0.19192688212649994,
  0,
  -0.9814092275484271,
  0.19192688212649994,
  0,
  -0.9814092275484271,
  0.22517453682616517,
  0,
  -0.9743184427922535,
  0.22517453682616517,
  0,
  -0.9743184427922535,
  0.22517453682616517,
  0,
  -0.9743184427922535,
  0.22517453682616517,
  0,
  -0.9743184427922535,
  0.22517453682616517,
  0,
  -0.9743184427922535,
  0.22517453682616517,
  0,
  -0.9743184427922535,
  0.2576687824952253,
  0,
  -0.9662333043977673,
  0.2576687824952253,
  0,
  -0.9662333043977673,
  0.2576687824952253,
  0,
  -0.9662333043977673,
  0.2576687824952253,
  0,
  -0.9662333043977673,
  0.2576687824952253,
  0,
  -0.9662333043977673,
  0.2576687824952253,
  0,
  -0.9662333043977673,
  0.28929201338125,
  0,
  -0.9572408949652239,
  0.28929201338125,
  0,
  -0.9572408949652239,
  0.28929201338125,
  0,
  -0.9572408949652239,
  0.28929201338125,
  0,
  -0.9572408949652239,
  0.28929201338125,
  0,
  -0.9572408949652239,
  0.28929201338125,
  0,
  -0.9572408949652239,
  0.32002313053853576,
  0,
  -0.9474097296947691,
  0.32002313053853576,
  0,
  -0.9474097296947691,
  0.32002313053853576,
  0,
  -0.9474097296947691,
  0.32002313053853576,
  0,
  -0.9474097296947691,
  0.32002313053853576,
  0,
  -0.9474097296947691,
  0.32002313053853576,
  0,
  -0.9474097296947691,
  0.3446300199038612,
  0,
  -0.938738594807449,
  0.3446300199038612,
  0,
  -0.938738594807449,
  0.3446300199038612,
  0,
  -0.938738594807449,
  0.3446300199038612,
  0,
  -0.938738594807449,
  0.3446300199038612,
  0,
  -0.938738594807449,
  0.3446300199038612,
  0,
  -0.938738594807449,
  0.3591263346811636,
  0,
  -0.9332889561858497,
  0.3591263346811636,
  0,
  -0.9332889561858497,
  0.3591263346811636,
  0,
  -0.9332889561858497,
  0.3591263346811636,
  0,
  -0.9332889561858497,
  0.3591263346811636,
  0,
  -0.9332889561858497,
  0.3591263346811636,
  0,
  -0.9332889561858497,
  0.3692704150425044,
  0,
  -0.9293219897184918,
  0.3692704150425044,
  0,
  -0.9293219897184918,
  0.3692704150425044,
  0,
  -0.9293219897184918,
  0.3692704150425044,
  0,
  -0.9293219897184918,
  0.3692704150425044,
  0,
  -0.9293219897184918,
  0.3692704150425044,
  0,
  -0.9293219897184918,
  0.38343280259308943,
  0,
  -0.9235687770250839,
  0.38343280259308943,
  0,
  -0.9235687770250839,
  0.38343280259308943,
  0,
  -0.9235687770250839,
  0.38343280259308943,
  0,
  -0.9235687770250839,
  0.38343280259308943,
  0,
  -0.9235687770250839,
  0.38343280259308943,
  0,
  -0.9235687770250839,
  0.40611174886474966,
  0,
  -0.9138234224586359,
  0.40611174886474966,
  0,
  -0.9138234224586359,
  0.40611174886474966,
  0,
  -0.9138234224586359,
  0.40611174886474966,
  0,
  -0.9138234224586359,
  0.40611174886474966,
  0,
  -0.9138234224586359,
  0.40611174886474966,
  0,
  -0.9138234224586359,
  0.43275786520554677,
  0,
  -0.901510194120254,
  0.43275786520554677,
  0,
  -0.901510194120254,
  0.43275786520554677,
  0,
  -0.901510194120254,
  0.43275786520554677,
  0,
  -0.901510194120254,
  0.43275786520554677,
  0,
  -0.901510194120254,
  0.43275786520554677,
  0,
  -0.901510194120254,
  0.45824591679032706,
  0,
  -0.8888254495371927,
  0.45824591679032706,
  0,
  -0.8888254495371927,
  0.45824591679032706,
  0,
  -0.8888254495371927,
  0.45824591679032706,
  0,
  -0.8888254495371927,
  0.45824591679032706,
  0,
  -0.8888254495371927,
  0.45824591679032706,
  0,
  -0.8888254495371927,
  0.47841610365634096,
  0,
  -0.8781332653773486,
  0.47841610365634096,
  0,
  -0.8781332653773486,
  0.47841610365634096,
  0,
  -0.8781332653773486,
  0.47841610365634096,
  0,
  -0.8781332653773486,
  0.47841610365634096,
  0,
  -0.8781332653773486,
  0.47841610365634096,
  0,
  -0.8781332653773486,
  0.4904483172997039,
  0,
  -0.8714702795034888,
  0.4904483172997039,
  0,
  -0.8714702795034888,
  0.4904483172997039,
  0,
  -0.8714702795034888,
  0.4904483172997039,
  0,
  -0.8714702795034888,
  0.4904483172997039,
  0,
  -0.8714702795034888,
  0.4904483172997039,
  0,
  -0.8714702795034888,
  0.49847112425808165,
  0,
  -0.8669063030575358,
  0.49847112425808165,
  0,
  -0.8669063030575358,
  0.49847112425808165,
  0,
  -0.8669063030575358,
  0.49847112425808165,
  0,
  -0.8669063030575358,
  0.49847112425808165,
  0,
  -0.8669063030575358,
  0.49847112425808165,
  0,
  -0.8669063030575358,
  0.5100296559885893,
  0,
  -0.8601568171049749,
  0.5100296559885893,
  0,
  -0.8601568171049749,
  0.5100296559885893,
  0,
  -0.8601568171049749,
  0.5100296559885893,
  0,
  -0.8601568171049749,
  0.5100296559885893,
  0,
  -0.8601568171049749,
  0.5100296559885893,
  0,
  -0.8601568171049749,
  0.5282812148449356,
  0,
  -0.8490694659696336,
  0.5282812148449356,
  0,
  -0.8490694659696336,
  0.5282812148449356,
  0,
  -0.8490694659696336,
  0.5282812148449356,
  0,
  -0.8490694659696336,
  0.5282812148449356,
  0,
  -0.8490694659696336,
  0.5282812148449356,
  0,
  -0.8490694659696336,
  0.5495745473540692,
  0,
  -0.8354446821307621,
  0.5495745473540692,
  0,
  -0.8354446821307621,
  0.5495745473540692,
  0,
  -0.8354446821307621,
  0.5495745473540692,
  0,
  -0.8354446821307621,
  0.5495745473540692,
  0,
  -0.8354446821307621,
  0.5495745473540692,
  0,
  -0.8354446821307621,
  0.5697616492287497,
  0,
  -0.8218099920712423,
  0.5697616492287497,
  0,
  -0.8218099920712423,
  0.5697616492287497,
  0,
  -0.8218099920712423,
  0.5697616492287497,
  0,
  -0.8218099920712423,
  0.5697616492287497,
  0,
  -0.8218099920712423,
  0.5697616492287497,
  0,
  -0.8218099920712423,
  0.5857392008968432,
  0,
  -0.810499591938656,
  0.5857392008968432,
  0,
  -0.810499591938656,
  0.5857392008968432,
  0,
  -0.810499591938656,
  0.5857392008968432,
  0,
  -0.810499591938656,
  0.5857392008968432,
  0,
  -0.810499591938656,
  0.5857392008968432,
  0,
  -0.810499591938656,
  0.59510704228549,
  0,
  -0.8036464447891347,
  0.59510704228549,
  0,
  -0.8036464447891347,
  0.59510704228549,
  0,
  -0.8036464447891347,
  0.59510704228549,
  0,
  -0.8036464447891347,
  0.59510704228549,
  0,
  -0.8036464447891347,
  0.59510704228549,
  0,
  -0.8036464447891347,
  0.6014611133277081,
  0,
  -0.7989020773252462,
  0.6014611133277081,
  0,
  -0.7989020773252462,
  0.6014611133277081,
  0,
  -0.7989020773252462,
  0.6014611133277081,
  0,
  -0.7989020773252462,
  0.6014611133277081,
  0,
  -0.7989020773252462,
  0.6014611133277081,
  0,
  -0.7989020773252462,
  0.6148034020884103,
  0,
  -0.7886804021785482,
  0.6148034020884103,
  0,
  -0.7886804021785482,
  0.6148034020884103,
  0,
  -0.7886804021785482,
  0.6148034020884103,
  0,
  -0.7886804021785482,
  0.6148034020884103,
  0,
  -0.7886804021785482,
  0.6148034020884103,
  0,
  -0.7886804021785482,
  -0.7808668582275605,
  0,
  -0.6246974865659528,
  -0.7808668582275605,
  0,
  -0.6246974865659528,
  -0.7808668582275605,
  0,
  -0.6246974865659528,
  -0.7808668582275605,
  0,
  -0.6246974865659528,
  -0.7808668582275605,
  0,
  -0.6246974865659528,
  -0.7808668582275605,
  0,
  -0.6246974865659528,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0.8000000000000002,
  0,
  0.6,
  0.8000000000000002,
  0,
  0.6,
  0.8000000000000002,
  0,
  0.6,
  0.8000000000000002,
  0,
  0.6,
  0.8000000000000002,
  0,
  0.6,
  0.8000000000000002,
  0,
  0.6,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  -0.9897924921059391,
  0,
  0.1425160432046673,
  -0.9897924921059391,
  0,
  0.1425160432046673,
  -0.9897924921059391,
  0,
  0.1425160432046673,
  -0.9897924921059391,
  0,
  0.1425160432046673,
  -0.9897924921059391,
  0,
  0.1425160432046673,
  -0.9897924921059391,
  0,
  0.1425160432046673,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0.9897924921059391,
  0,
  0.1425160432046673,
  0.9897924921059391,
  0,
  0.1425160432046673,
  0.9897924921059391,
  0,
  0.1425160432046673,
  0.9897924921059391,
  0,
  0.1425160432046673,
  0.9897924921059391,
  0,
  0.1425160432046673,
  0.9897924921059391,
  0,
  0.1425160432046673,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -0.8000000000000002,
  0,
  0.6,
  -0.8000000000000002,
  0,
  0.6,
  -0.8000000000000002,
  0,
  0.6,
  -0.8000000000000002,
  0,
  0.6,
  -0.8000000000000002,
  0,
  0.6,
  -0.8000000000000002,
  0,
  0.6,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  1,
  0
]



// WEBPACK FOOTER //
// ./src/components/WebGLView/normal.js